import * as URL from '../../utility/url';
import * as Event from '../../events';
import {logout} from '../../services/authenticated';
import Article from './article';
import Product from './product';
import Category from './category';
import Visitor from '../../services/visitor';

class Administrator {
    constructor(pattern, data) {
        this.pattern = pattern;
        this.userData = data;
        this.href = "";
    }
    
    handleArticle() {
        var article = new Article('article');
        
        this.pattern = /\/admin\/article\/.*/;
        URL.parse('', this.pattern).then(request => {
            if (request == '/admin/article/create.html') {
                return article.create();
            } else if (request == '/admin/article/index.html') {
                return article.index();
            }
        }).catch(error => {});
    }
    
    handleCategory() {
        var category = new Category('category');
        
        this.pattern = /\/admin\/category\/.*/;
        URL.parse('', this.pattern).then(request => {
            if (request == '/admin/category/create.html') {
                return category.create();
            } else if (request == '/admin/category/index.html') {
                return category.index();
            }
        }).catch(error => {});
    }
    
    handleLogout() {
        this.pattern = /\/admin\/.*/;
        URL.parse('', this.pattern).then(request => {
            if (request == '/admin/logout.html') {
                return this.logout();
            }
        }).catch(error => {});
    }
    
    handleProduct() {
        var product = new Product('products');
        
        this.pattern = /\/admin\/product\/.*/;
        URL.parse('', this.pattern).then(request => {
            if (request == '/admin/product/create.html') {
                return product.create();
            } else if (request == '/admin/product/index.html') {
                return product.index();
            }
        }).catch(error => {});
    }
    
    filterUrl(callback) {
        return URL.parse('', this.pattern)
            .then(response => callback(response))
            .catch(error => {}/*Event.Exception(error)*/); // uncomment this for developer
    }
    
    getServices() {
        this.handleLogout();
        this.handleArticle();
        this.handleProduct();
        this.handleCategory();
        this.getVisitor();
    }
    
    getVisitor() {
        var visitor = new Visitor('visitor');
        return visitor.index();
    }
    
    logout() {
        const {uid} = this.userData;
        Event.loading(length => {
            if (length == 100) {
                return logout(uid);
            }
        });
    }
}

export default Administrator;